<!-- 教育局-校外培训机构 -->
<template>
  <div class="index">
    <div class="header">
      <div class="header_left">
        <p>您即将跳转访问全国校外教育培训监管与服务综合平台</p>
        <p>登录后，在“机构管理”栏目下即可查看校外培训机构相关数据。</p>
      </div>
      <el-button type="primary" @click="open">继续访问</el-button>
    </div>
    <img class="bg" src="@/assets/img/education/xwjg_bg.png" alt="">
  </div>
</template>

<script>
// import { getTicket } from "@/utils-khfw/ticket.service.js";
import { getTicket } from "@/api/user/userCenter.js";

export default {
  components: {
  },
  data() {
    return {

    };
  },
  mounted() {},
  created() {

  },
  methods: {
    async open(){
      let uid = sessionStorage.getItem("usessionid");
      // let platformCode = sessionStorage.getItem("platformCode");
      // let ticket = await getTicket(uid);
      // window.open(
      //   `https://xwpx.eduyun.cn/bmp-web/?ticket=${ticket}&platformcode=${platformCode}`
      // );
      // window.open(
      //  'https://static.eduyun.cn:40017/nationSystem/service_system_dev/system/train_supervision_platform/%E6%9C%BA%E6%9E%84%E7%AE%A1%E7%90%86.html'
      // );
      window.open('https://xwpx.eduyun.cn/bmp-web/')
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 20px 100px 30px;
  .header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_left{
      p{
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
  .bg{
    max-width: 100%;
    margin-top: 30px;
  }
}

</style>
